<template>
  <div class="header sticky-top position-relative">
    <div class="container" v-if="windowWidth > 768">
      <div class="row">
        <div class="col-3">
          <a
              aria-label="futalis Logo"
              class="navbar-brand position-relative"
              style="background-color: white"
              id="HEADER_FUTALIS_LOGO"
              href="javascript:void(0)"
          >
            <i @click="handleOnLogoClick" class="icon-futalis-vet-green"/>
          </a>
        </div>
        <div class="col-9 ellipsis">
          <div class=" h-50 d-inline-flex float-right">
            <div
                class="h-100 d-block p-relative"
                id="HEADER_ADDRESS_BOOK_BUTTON"
            >
              <button
                  aria-label="Patientenregister"
                  @click="handleOnAddressBookClick"
                  class=" futalis-button-orange btn-header h-100"
                  :disabled="!user.identity.id"
                  :class="{ 'bg-disabled': !user.identity.id }"
              >
                <i class="icon-patientenregister"/>
              </button>
            </div>
            <button
                type="button"
                @click.stop="trigger"
                aria-label="Warenkorb"
                id="header_cart_button"
                class="ml-4 futalis-button-green btn-cart"
            >
              <i class="icon-shopping-cart  " id="header_cart_button_icon"/>
            </button>

            <div id="minicart-wrapper" style="margin-top: 50px; position: relative;" />

            <span id="btn-cart-count-items"
                class="font-weight-bold cart-content badge text-white futalis-bg-dark-green">0</span>

            <button
                type="button"
                @click="handleOnMyAccountClick"
                class="ml-2 btn-header d-inline-flex futalis-button-green"
            >
              <i class="icon-konto"/>
              <span class="badge text-white konto-content">Mein Konto</span>
            </button>
            <button
                type="button"
                aria-label="Logout"
                @click="handleOnLogoutClick"
                class="btn-header btn-log-out ml-2"
                v-if="this.$route.name !== 'LogIn'"
            >
              <i style="color: #ffffff;" class="fas fa-sign-out-alt"></i>
            </button>
          </div>
        </div>
      </div>
    </div>
    <div v-else>
      <div class="pl-3 d-flex">
        <div class="px-2 py-2 clickable" @click="handleMobileMenuDisplay">
          <i style="font-size: 1.5rem" class="futalis-text-green fad fa-3x fa-bars"></i>
        </div>
        <div class="w-100 center-middle" style="margin-top: -3px">
          <router-link
              id="HEADER_FUTALIS_LOGO"
              to="/"

              class="navbar-brand float-right"
              href="javascript:void(0)"
          >
            <i class="icon-futalis-vet-green"/>
          </router-link>
        </div>
        <div style="margin-top: 12px;" class="float-right mr-3">
          <i
            style="font-size: 20px;"
            id="header_cart_button_mobile"
            class="far clickable fa-shopping-cart futalis-text-green"
          />
        </div>
      </div>

      <div id="minicart-wrapper-mobile" style="position: relative; margin-top: -8px" />
    </div>
    <div v-if="isMobileMenuVisible">
      <div class="navigation-mobile">
        <div class="px-3 py-2">
          <i
              class="fad fa-times fa-3x text-white clickable"
              @click="handleMobileMenuDisplay"
          />
        </div>
        <ul class="list-unstyled mx-4">
          <li class="navigation-mobile-item" @click="handleOnLogoClick">
            Startseite
          </li>
          <li class="navigation-mobile-item" @click="handleOnAddressBookClick">
            Patientenregister
          </li>
          <li class="navigation-mobile-item" @click="handleOnCheckOutClick">
            Warenkorb
          </li>
          <li class="navigation-mobile-item" @click="handleOnMyAccountClick">
            Mein Konto
          </li>
          <li class="navigation-mobile-item" @click="handleOnLogoutClick">
            Logout
          </li>
        </ul>
      </div>
    </div>
    <div class="w-100 center-middle">
      <div id="WELCOME_SCREEN"></div>
    </div>
  </div>
</template>

<script>
import {mapState} from 'vuex';
import router from '@/modules/router/config';
import {CONSTANTS} from '@/constants/guide';
import eventBus from "@/modules/bus"

export default {
  name: 'Header',
  props: ['displayCart', 'windowWidth'],
  components: {},
  data() {
    return {
      showMenu: false
    };
  },
  computed: {
    ...mapState({
      user: state => state.authModule.user,
      checkout: state => state.checkOutModule
    }),
    isMobileMenuVisible() {
      return this.windowWidth <= 768 && this.showMenu === true;
    }
  },
  methods: {
    trigger() {
      const next = () => setTimeout(() => {
        const cartPopUp = document.getElementById('minicart')
        cartPopUp.style.display = 'block'
      }, 0)
      this.$route.name === 'Configurator' 
        ? eventBus.$emit('route-changed', next)
        : next()
    },
    handleOnLogoClick() {
      this.showMenu = false;
      this.$emit('defaultHome');
    },
    handleOnAddressBookClick() {
      this.showMenu = false;
      if (
          this.$route.name == 'checkout' &&
          this.checkout.cart.items.length != 0 &&
          this.checkout.petToSelectClientFor.id != 0
      ) {
        const mountOptions =  {
          action: 'ASSIGN_PET_TO_CLIENT',
          payload: {
            petId: this.checkout.petToSelectClientFor.id,
            petName: this.checkout.petToSelectClientFor.name
          }
        }
        this.$store.commit('addressBookModule/displayAddressBook',{ mountOptions });
        return;
      }

      if (
          this.$route.name == 'checkout' &&
          this.checkout.cart.items.length == 0
      ) {
        router
            .push({
              path: `/Configurator/${CONSTANTS.CONFIGURATOR.MODES.NEW_PET}/`
            })
            .then(promise => {
              this.$store.commit('addressBookModule/displayAddressBook');
            });

        return;
      }

      let self = this;
      this.checkShowLeaveCartPopup(function () {
        self.$store.commit('addressBookModule/displayAddressBook');
      });
    },
    handleMobileMenuDisplay() {
      this.showMenu = !!!this.showMenu;
    },
    handleOnMyAccountClick() {
      const next = () => {
        this.showMenu = false;
        this.checkShowLeaveCartPopup(function () {
          location.href = '/configurator/interface_account';
        });
      }
      this.$route.name === 'Configurator' 
        ? eventBus.$emit('route-changed', next)
        : next()
    },
    handleOnCheckOutClick() {
      this.showMenu = false;
      router.push({name: 'checkout'});
    },
    async handleOnLogoutClick() {
      const next = async () => {
        this.showMenu = false;
        if (this.$route.name !== 'checkout') {
          await this.$store.dispatch('checkOutModule/clearCart');
          this.$emit('logOut');
          return;
        }
        await this.$swal({
          title:
              'Sie haben Artikel im Warenkorb. Möchten Sie sich wirklich ausloggen?',
          showConfirmButton: true,
          confirmButtonColor: '#2778c4',
          showCancelButton: true,
          confirmButtonText:
              'Ja, ich möchte mich ausloggen und die Bestellung verwerfen.',
          cancelButtonText: 'Nein, ich möchte eingeloggt bleiben.',
          customClass: 'logout-ask'
        }).then(result => {
          if (result.isConfirmed) {
            this.$store.dispatch('checkOutModule/clearCart');
            this.$emit('logOut');
          }
        });
      }
      this.$route.name === 'Configurator' 
        ? eventBus.$emit('route-changed', next)
        : next()
    },
    checkShowLeaveCartPopup(callback) {
      if (
          this.$route.name == 'checkout' &&
          this.checkout.cart.items.length > 0
      ) {
        this.$store.commit('checkOutModule/openLeaveCartPopup', callback);
      } else {
        callback();
      }
    }
  },
  mounted() {
  }
};
</script>

<style lang="sass" scoped>

.btn-header
  font-weight: 400
  border: 1px solid transparent
  padding: 0.2rem 0.6rem 0.1rem
  font-size: 1rem
  line-height: 1.5
  border-radius: 0 0 0.2rem 0.2rem

.btn-cart
  border: 1px solid transparent
  padding: 0.1rem 0.1rem 0.2rem 0.4rem
  line-height: 1.5
  border-radius: 0 0 0 0.2rem

span.cart-content
  font-size: 1rem
  padding-top: 0.8rem
  border-radius: 0 0 0.2rem 0

span.konto-content
  font-size: 0.9rem
  padding-top: 0.6rem
  font-weight: 500


button.btn-log-out
  background-color: #666666
  padding-right: .78rem !important
  padding-left: .82rem !important

button.btn-log-out:hover
  background-color: #8c8c8c

.bg-disabled
  background-color: #777777 !important

.navigation-mobile
  position: fixed
  top: 0
  left: 0
  bottom: 0
  right: 0
  background-color: #454545
  z-index: 9999
  text-align: left
  overflow-y: scroll
  overflow-x: hidden

.navigation-mobile-item
  border-bottom: 1px solid #fff
  text-align: center
  font-size: 20px
  color: #ffffff
  padding-top: 1rem
  padding-bottom: 1rem
  cursor: pointer

.sticky-top
  z-index: initial !important
</style>
